import { useEffect, useState } from 'react'
import { fetchAuthSession } from '@aws-amplify/auth'

import { Spinner } from '@/components'

const DEPLOYMENT_APP_URL = 'https://frontend-deployment.treezecomm.app'

export const FrontendDeploymentPage = () => {
  const [iframeSrc, setIframeSrc] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    const loadEmbedUrl = async () => {
      const session = await fetchAuthSession()
      const idToken = session.tokens?.idToken?.toString()

      if (!cancelled && idToken) {
        setIframeSrc(buildDeploymentEmbedUrl(idToken))
      }
    }

    void loadEmbedUrl()

    return () => {
      cancelled = true
    }
  }, [])

  if (!iframeSrc) {
    return <Spinner />
  }

  return (
    <iframe
      src={iframeSrc}
      title="Front Deployment"
      className="w-full h-[calc(100dvh-10rem)] border-0 rounded-lg bg-white"
    />
  )
}

export function buildDeploymentEmbedUrl(
  idToken: string,
  options?: {
    baseUrl?: string
    path?: string
    searchParams?: Record<string, string>
  },
): string {
  const baseUrl = options?.baseUrl ?? DEPLOYMENT_APP_URL
  const path = options?.path ?? '/'
  const url = new URL(path, baseUrl)

  url.searchParams.set('cognito_token', idToken)

  for (const [key, value] of Object.entries(options?.searchParams ?? {})) {
    url.searchParams.set(key, value)
  }

  return url.toString()
}
